app.service('guestKmeLogin', function (validate, loading, captchaService) {
	var $form, $errorText;
	function init() {
		$form = $('#guest-kme-login form');
		$errorText = $form.find('.error-text');
		addLoginCaptcha();
		validate.task('guestKMELogin', function () {
			formSend();
		});
	}
	function addRecaptchaToken(token, data) {
		if (token) {
			data.push({
				name: 'g-recaptcha-response',
				value: token
			});
		}
	}
	function addLoginCaptcha() {
		let $captcha = $form.find('[data-toggle="captcha"]');
		if ($captcha.length) {
			captchaService.load($captcha.attr('id'), $captcha.data('place'));
		}
	}
	function formSend() {

		var data = $form.find('input').serializeArray();
		const token = $form.find('[data-toggle="captcha"] .g-recaptcha-response').val();
		const idCaptcha = $form.find('[data-toggle="captcha"]').attr('id');
		addRecaptchaToken(token, data);
		
		var url = '/guest_order_j_spring_security_check.ltr';
		loading.start();
		$.ajax({
			url: url,
			type: 'POST',
			data: data,
			success: function (txt) {
				loading.stop();
				if( txt.indexOf('verification_error') > -1){
					$errorText.html('<h2>Wpisany e-mail i numer zamówienia nie pasują do siebie.</h2><p>Sprawdź, czy dane zostały wpisane poprawnie – najlepiej skopiuj je bezpośrednio z e-maila potwierdzającego zamówienie.</p>');
					captchaService.reset(idCaptcha);
					addLoginCaptcha();
				} else if(txt.length > 100){
					$errorText.html('<h2>Napotkaliśmy nieoczekiwane problemy.</h2><p>Nie udało się poprawnie zalogować. Spróbuj ponownie lub skontaktuj się z infolinią</p>');
				} else{
					loading.redirect(txt);
				}
			},
			error: function () {
				loading.stop();
				$errorText.text('Błąd komunikacji. Prosimy spróbować raz jeszcze!');
			}
		});

	}
	return {
		init
	};
});